const LIST_KEY_NAME = 'ISBNList'

export {
  LIST_KEY_NAME
}
